export default __webpack_public_path__ + "static/media/my-check-image.21c5df9f.svg";